'use client';

import React, { Component } from 'react';
import './style.sass';

import Team from '../reusable-components/layouts-components__converter/team';
import PortfolioGallery from '../reusable-components/layouts-components__converter/portfolio-gallery';
import Blocks from '../reusable-components/layouts-components__converter/blocks';
import Process from '../reusable-components/layouts-components__converter/process';
import Graph from '../reusable-components/layouts-components__converter/graph';
import Complex from '../reusable-components/layouts-components__converter/complex';
import Tasks from '../reusable-components/layouts-components__converter/tasks';
import Goals from '../reusable-components/layouts-components__converter/goals';
import Review from '../reusable-components/layouts-components__common-cases/review';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';

import CommonSmallTitle from '../common-components/common-small-title';
import CommonSmallText from '../common-components/common-small-text';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import CommonNav from '../common-components/common-nav';

const gensMainTitle = {
    titleMainText: `Создали платформу для&nbsp;онлайн-конвертации с&nbsp;трафиком 1&nbsp;500&nbsp;000 посетителей`,
    titleAnimation: '/images/pic/preview/converter.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#009bcc',
            nameText: 'Вебпрактик',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#009bcc',
            nameText: 'Технологии',
        },
        {
            modeText: 'Услуги',
            colorMode: '#009bcc',
            nameText: 'Создание и&nbsp;запуск сервиса на&nbsp;международный рынок',
        },
        {
            modeText: 'Технологии',
            colorMode: '#009bcc',
            nameText:
                'Node.js, Express.js, PHP, Laravel, Bitrix, React, MobX, Docker, Kubernetes, Socket.io, Codeception, Gearman, Prometheus, Grafana, Sentry',
        },
    ],
};

const reviewGens = {
    reviewTitle: 'Руководитель о проекте',
    reviewText:
        'Проект научил нас не&nbsp;бояться амбициозных задач. Когда ставишь перед собой цель быть &#8470;&nbsp;1&nbsp;в мире, подходящие решения сами находят тебя. Главное&nbsp;&mdash; не&nbsp;бояться идти по&nbsp;этому пути изо дня в&nbsp;день.',
    reviewAuthors: [
        {
            title: 'Александр Букуров',
            subtitle: 'владелец продукта',
            img: '/images/pic/converter/converter__reviewAuthorImg.jpg',
        },
    ],
};

class Converter extends Component {
    render() {
        const casePathname = '/cases/products/converter';
        const adjacentCase = getAdjacentCase(casePathname);

        return (
            <section className="converter">
                <CommonNav
                    stepOne="Главная"
                    stepTwo="Кейсы"
                    stepThree="Продукты"
                    link1={'/'}
                    link2={'/cases'}
                    link3={true}
                />
                <MainTitle MainTitle={gensMainTitle}>
                    <CommonSmallTitle className="converter__subtitle">
                        Onlineconvertfree.com
                    </CommonSmallTitle>
                    <CommonSmallText>
                        Это собственный сервис компании по&nbsp;конвертации файлов. Сегодня
                        он&nbsp;входит в&nbsp;ТОП-5 онлайн-конвертеров в&nbsp;мире. Сервисом
                        ежемесячно пользуются 1,3&nbsp;млн. посетителей из&nbsp;220&nbsp;стран.
                        Он&nbsp;поддерживает 231 формат и&nbsp;2600 направлений конвертации.
                    </CommonSmallText>
                </MainTitle>

                <PortfolioGallery />

                <Goals />

                <Tasks />

                <Complex />

                <Graph />

                <Process />

                <Blocks />

                <Team />

                <Review Review={reviewGens} />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                {adjacentCase && (
                    <NextProject
                        NextProject={{
                            nextProjectTitle: adjacentCase.case.title,
                            nextProjectImg: adjacentCase.case.image,
                            nextProjectLink: adjacentCase.case.router,
                            nextProjectText: adjacentCase.case.description,
                            nextProjectLabel: adjacentCase.label,
                        }}
                    />
                )}
            </section>
        );
    }
}

export default Converter;
